export enum APPROVAL_STATUS {
  DRAFT = "Draft",
  IN_PROGRESS = "In Progress",
  WORK_CAN_START = "Work Can Start",
  APPROVED = "Approved",
  READY_FOR_CREATIVE_REVIEW = "Ready for Creative Review",
}
